import { useQuery } from 'react-query';
import { cacheKeys } from 'config';
import { surveysClient } from '../client/surveysClient';
import { Surveys } from '../surveys';


export const useSurveysData = (getAllParams?: Surveys.GetSurveysParams) => {

  const {
    data: { data: surveysData } = {},
    isLoading,
  } = useQuery(
    [cacheKeys.surveys.getSurveys, getAllParams],
    async () => {
      const res = await surveysClient.getSurveys(getAllParams);

      return res;
    },
  );

  return {
    surveys: surveysData?.results || [],
    surveysCount: surveysData?.count || 0,
    isLoading,
  };
};
